import React from 'react';
// import { Button } from 'antd';
import QueueAnim from 'rc-queue-anim';
import TweenOne from 'rc-tween-one';
// import Texty from 'rc-texty';
import 'rc-texty/assets/index.css';
import { getChildrenToRender } from '../../utils';

/* replace-start */
import './index.less';
/* replace-end */
class Banner extends React.PureComponent {
  render() {
    const { ...currentProps } = this.props;
    const { dataSource } = currentProps;
    delete currentProps.dataSource;
    delete currentProps.isMobile;
    const children = dataSource.textWrapper.children.map(getChildrenToRender);

    const animType = {
      queue: 'bottom',
      one: {
        y: '+=30', opacity: 0, type: 'from', ease: 'easeOutQuad',
      },
    };

    return (
      <div {...currentProps} {...dataSource.wrapper}>
        <TweenOne
          animation={animType.one}
          key="title"
          {...dataSource.image}
          data-edit="image"
        >
          <img src={dataSource.image.children} width="100%" alt="img" />
        </TweenOne>
        <QueueAnim
          key="QueueAnim"
          type={['bottom', 'top']}
          delay={300}
          {...dataSource.textWrapper}
        >
          {children}
        </QueueAnim>
      </div>
    );
  }
}
export default Banner;
